var map = {
	"./Gilroy-Regular.ttf": 28,
	"./Gilroy-Regular.woff": 29,
	"./Gilroy-Regular.woff2": 30,
	"./Gilroy-SemiBold.ttf": 31,
	"./Gilroy-SemiBold.woff": 32,
	"./Gilroy-SemiBold.woff2": 33
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27;